import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const companyApi = createApi({
    reducerPath: 'companyApi',
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    tagTypes: ['company'],
    endpoints: build => ({
        getCompany: build.query({
            query: ({id, ...data}) => ({
                url: api.company.getCompany(id),
                method: 'GET',
                params: data
            }),
            providesTags: ['company']
        }),
        getCompanies: build.query({
            query: (data) => ({
                url: api.company.getCompanies(),
                method: 'GET',
                params: data
            }),
            providesTags: ['company']
        }),
        createCompany: build.mutation({
            query: (data) => ({
                url: api.company.createCompany(),
                method: 'POST',
                body: data
            })
        }),
        updateSubscription: build.mutation({
            query: ({id, ...data}) => ({
                url: api.company.updateSubscription(id),
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['company']
        }),
        impersonate: build.mutation({
            query: (data) => ({
                url: api.company.impersonate(),
                method: 'POST',
                body: data
            })
        })
    })
})

export const { useGetCompanyQuery, useLazyGetCompanyQuery, useLazyGetCompaniesQuery } = companyApi
